angular.module('am4').directive('clickToEnableInput', function($timeout) {
    return {
        restrict: 'AE',
        scope: true,
        link: function(scope, element) {
            scope.isEditing = false;
            var inputElement = element.find('input, select, textarea')[0];
            element.addClass('am4-inline-editable');
            angular.element(inputElement).on('blur', function() {
                scope.isEditing = false;
            });

            scope.edit = function() {
                scope.isEditing = true;

                $timeout(function() {
                    inputElement.focus();
                });
            };

            element.on('click', function() {
                scope.edit();
            });
        }
    };
});


// WEBPACK FOOTER //
// ./src/app/directives/enableInput.js